import Caret from './caret.svg';

export default Caret;
